import { Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { graphql, useFragment } from 'react-relay';

import { CHARGE_STATUS_ENUM } from '@woovi/shared';
import { ActionButton } from '@woovi/ui';

import type { PaymentShopify_charge$key } from './__generated__/PaymentShopify_charge.graphql.ts';

const IS_SERVER = typeof window === typeof undefined;

type Props = {
  charge: PaymentShopify_charge$key;
};

const PaymentShopify = (props: Props): ReactNode => {
  const { t } = useTranslation();

  const charge = useFragment<PaymentShopify_charge$key>(
    graphql`
      fragment PaymentShopify_charge on Charge {
        isShopifyCharge
        status
      }
    `,
    props.charge,
  );

  const theme = useTheme();

  if (!charge.isShopifyCharge) {
    return null;
  }

  if (charge.status !== CHARGE_STATUS_ENUM.ACTIVE) {
    return null;
  }

  if (!IS_SERVER) {
    if (window.history.length < 1) {
      return null;
    }
  }

  const handleBack = (): void => {
    if (IS_SERVER) {
      return;
    }

    window.history.back();
  };

  return (
    <Stack
      sx={{
        alignItems: 'center',
        justifyContent: 'center',
        pt: theme.spacing(2),
      }}
    >
      <Stack mb={2} gap={2} sx={{ alignItems: 'center' }}>
        <ActionButton onClick={() => handleBack()}>
          {t('Return to Shopify Checkout')}
        </ActionButton>
      </Stack>
    </Stack>
  );
};

export default PaymentShopify;
